import React from 'react'

const IconWrapper = ({children}) => {
  return (
    <span className='flex center radius-full icon'>
        {children}
    </span>
  )
}

export default IconWrapper